import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-condition-public',
  templateUrl: './terms-condition-public.component.html',
  styleUrls: ['./terms-condition-public.component.scss']
})
export class TermsConditionPublicComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
